import React from 'react'
import './style.css'
export default function Footer() {
  return (
    <div className='footer'>
      <p>Copyright <b>@</b> Desenvolvido por <a href="https://www.github.com/vbanety" target='_blank'><b>Vinicius Batista</b></a></p>
    </div>
  )
}
